import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';

import Settings from '../../pages/Settings';
import { StoreProvider } from '../../components';

const Container = createFragmentContainer(Settings, {
  invoiceSettings: graphql`
    fragment BillingSettingsContainer_invoiceSettings on InvoiceSettings {
      id
      wiringInstructions
      contactPerson
      contactPhoneNumber
      contactEmail
    }
  `,
});

const BillingSettingsContainer = (props) => {
  return (
    <StoreProvider
      container={Container}
      modern
      query={graphql`
        query BillingSettingsContainerQuery {
          invoiceSettings {
            ...BillingSettingsContainer_invoiceSettings
          }
        }
      `}
      {...props}
    />
  );
};

export default BillingSettingsContainer;
